var React = require('react');

function FacebookCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"#3D5A96","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.353 28.205h-3.638v-7.749h-1.817V17.47h1.817v-1.791c0-2.435 1.027-3.884 3.943-3.884h2.427v2.986H22.57c-1.136 0-1.211.417-1.211 1.196l-.005 1.493h2.75l-.323 2.986h-2.427v7.75Z","fill":"#fff","key":1})]);
}

FacebookCircle.defaultProps = {"viewBox":"0 0 40 40","fill":"none"};

module.exports = FacebookCircle;

FacebookCircle.default = FacebookCircle;
